import styles from '@/styles/_variables.scss';
/**
 * This mixing helps to use mediaqueries into JS.
 * These mediaqueries are set on variables.scss -> $breakpoints
 * How to use:
 * :class="{ 'my-super-class-name': responsive.sm }
*/
export default {
  data() {
    // const mediaQuery = window.matchMedia
    this.breakpoints = styles.breakpoints.split(',').map((i) => i.trim());
    this.breakpointsValues = styles.breakpointsValues.split(',').map((i) => i.trim());

    const responsive = this.breakpoints.reduce((a, b) => {
      a[b] = false;
      return a;
    }, {});

    return {
      responsive,
    };
  },
  mounted() {
    this.mediaQuery();
    // TODO: Remove listeners.
  },
  methods: {
    mediaQuery() {
      this.breakpoints.forEach((i, index) => {
        const breakpoint = this.breakpointsValues[index];
        const mediaQuery = window.matchMedia(`screen and (min-width: ${breakpoint})`);
        const handleMQ = (e) => {
          if (e.matches) {
            this.$set(this.responsive, i, true);
          } else {
            this.$set(this.responsive, i, false);
          }
        };
        mediaQuery.addEventListener('change', handleMQ);
        handleMQ(mediaQuery); // Initial check
      });
    },
  },
};
